import GoalsDashboard from "../../../../../../image/icon/GoalsDashboard";
import Goals from "../../../../../../image/icon/Goals";

export const SIDEBAR_TABS = {
  oneascent: {
    proposal: [
      {
        Icon: GoalsDashboard,
        path: "/oneascent-proposal/dashboard",
        text: "Dash",
      },
      {
        Icon: Goals,
        path: "/oneascent-proposal/goals",
        text: "Investments",
      },
    ],
  },
  rivershares: {
    proposal: [
      {
        Icon: Goals,
        path: "/rivershares-proposal",
        text: "Goals",
      },
    ],
  },
};
